import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import AddressesBlock from '../../components/AddressesBlock/AddressesBlock';
import HistoryBlock from '../../components/HistoryBlock';
import IconBox from '../../components/IconBox';
import PageHeader from '../../components/PageHeader';
import HelperService from '../../services/HelperService';
import TypesService from '../../services/TypesService';

import './Asset.scss';

const BlockchainsById = TypesService.BlockchainsById;
const CurrenciesById = TypesService.CurrenciesById;

const HEADER_ICON_SIZE = 56;

const Asset = () => {
	const [currency, setCurrency] = useState();

	const availableCurrencies = useSelector(store => store.app.availableCurrencies);

	const [searchParams] = useSearchParams();
	const currencyId = searchParams.get('currencyId');

	const currencyData = CurrenciesById[currencyId];
	const currencyBlockchainData = BlockchainsById[currencyData?.BlockchainId];

	useEffect(() => {
		const currency = availableCurrencies.find(({ Id }) => Id === Number(currencyId));
		setCurrency(currency);
	}, []);

	function getDisplayName(currency) {
		const mapped = CurrenciesById[currency.Id];

		if (!mapped) return currency.Name || currency.Symbol;

		if (mapped.Standart) {
			const blockchain = BlockchainsById[currency.BlockchainId];
			const network = blockchain?.Name || '';

			return `${mapped.Name} ${network || ''} (${mapped.Standart})`.trim();
		}

		return `${mapped.Name} ${mapped.Company}`;
	}

	return (
		<div className='Asset'>
			<PageHeader />
			<div className='Asset__body'>
				{currency && (
					<>
						<div className='Asset__header'>
							<div>
								<div className='Asset__header-currency'>{getDisplayName(currency)}</div>
								<div className='Asset__header-balance'>
									{HelperService.FormatCrypto(
										currency.Amount,
										HelperService.GetCurrencyPrecisionByName(currency.Symbol)
									)}
								</div>
								<div className='Asset__header-balance-usd'>
									{'$' + HelperService.FormatFiatWithoutCurrency(currency.AmountUsd)}
								</div>
							</div>
							<IconBox
								icon={currencyData?.CompanyIcon}
								iconLabel={
									currencyData?.CompanyIcon !== currencyBlockchainData?.Icon ? currencyBlockchainData?.Icon : null
								}
								size={HEADER_ICON_SIZE}
							/>
						</div>
						<AddressesBlock currency={currency} />
						<HistoryBlock currencyId={currency.Id} />
					</>
				)}
			</div>
		</div>
	);
};

export default Asset;
